import { bookingInfoConstants } from '../constants';

const initialState: {
  bookingIdToInfoRes: {
    [bookingNo: string]: {
      isLoading?: boolean;
      bookingInfoRes?: object;
      error?: string;
    };
  };
  showingIndex: null | number;
  isLoadingAtRowIndex: { [rowIndex: number]: boolean };
} = {
  bookingIdToInfoRes: {},
  showingIndex: null,
  isLoadingAtRowIndex: {},
};

const getUpdatedIsLoadingAtRowIndex = (
  prevIsLoadingAtRowIndex: { [rowIndex: number]: boolean },
  rowIndexes?: number[],
  val?: boolean,
) => {
  if (!rowIndexes) return prevIsLoadingAtRowIndex;
  return {
    ...prevIsLoadingAtRowIndex,
    ...rowIndexes.reduce(
      (acc, rowIndex) => ({ ...acc, [rowIndex]: val || false }),
      {},
    ),
  };
};

export const bookingInfoRes = (
  state = initialState,
  action: { type: string; payload: any },
) => {
  let newData = {};
  switch (action.type) {
    case bookingInfoConstants.RESET:
      return initialState;
    case bookingInfoConstants.SHOW_BOOKING_INFO_AT_INDEX:
      return {
        ...state,
        showingIndex: action.payload.index,
      };
    case bookingInfoConstants.CLOSE_BOOKING_INFO:
      return {
        ...state,
        showingIndex: null,
      };
    case bookingInfoConstants.MANY_BOOKING_INFO_REQUEST:
      if (!action.payload.bookingNos)
        throw Error(`payload.bookingNos is missing`);
      newData = {
        isLoading: true,
      };
      return {
        ...state,
        isLoadingAtRowIndex: getUpdatedIsLoadingAtRowIndex(
          state.isLoadingAtRowIndex,
          action.payload.rowIndexes,
          true,
        ),
        bookingIdToInfoRes: action.payload.bookingNos.reduce(
          (acc, bn) => ({
            ...acc,
            [bn]: state[bn]
              ? {
                  ...state[bn],
                  ...newData,
                }
              : newData,
          }),
          state.bookingIdToInfoRes || {},
        ),
      };
    case bookingInfoConstants.MANY_BOOKING_INFO_SUCCESS:
      if (!action.payload.bookingInfoRes)
        throw Error(`payload.bookingInfoRes is missing`);
      return {
        ...state,
        isLoadingAtRowIndex: getUpdatedIsLoadingAtRowIndex(
          state.isLoadingAtRowIndex,
          action.payload.rowIndexes,
          false,
        ),
        bookingIdToInfoRes: action.payload.bookingInfoRes.bookings.reduce(
          (acc, booking) => {
            newData = {
              isLoading: false,
              bookingInfoRes: {
                bookings: [booking],
                opusFields: action.payload.bookingInfoRes.opusFields,
                shineFields:
                  action.payload.bookingInfoRes.shineFields,
              },
            };
            return {
              ...acc,
              [booking.bookingNo]: state[booking.bookingNo]
                ? {
                    ...state[booking.bookingNo],
                    ...newData,
                  }
                : newData,
            };
          },
          state.bookingIdToInfoRes || {},
        ),
      };
    case bookingInfoConstants.MANY_BOOKING_INFO_ERROR:
      if (!action.payload.bookingNos)
        throw Error(`payload.bookingNos is missing`);
      if (!action.payload.error)
        throw Error(`payload.error is missing`);
      newData = {
        isLoading: false,
        error: action.payload.error,
      };
      return {
        ...state,
        isLoadingAtRowIndex: getUpdatedIsLoadingAtRowIndex(
          state.isLoadingAtRowIndex,
          action.payload.rowIndexes,
          false,
        ),
        bookingIdToInfoRes: action.payload.bookingNos.reduce(
          (acc, bn) => {
            return {
              ...acc,
              [bn]: state[bn]
                ? {
                    ...state[bn],
                    ...newData,
                  }
                : newData,
            };
          },
          state.bookingIdToInfoRes || {},
        ),
      };
    case bookingInfoConstants.BOOKING_INFO_REQUEST:
      newData = {
        isLoading: true,
      };
      return {
        ...state,
        bookingIdToInfoRes: {
          ...(state.bookingIdToInfoRes || {}),
          [action.payload.bookingNo]: state[action.payload.bookingNo]
            ? {
                ...state[action.payload.bookingNo],
                ...newData,
              }
            : newData,
        },
      };
    case bookingInfoConstants.BOOKING_INFO_SUCCESS:
      newData = {
        isLoading: false,
        bookingInfoRes: action.payload.bookingInfoRes,
      };
      return {
        ...state,
        bookingIdToInfoRes: {
          ...(state.bookingIdToInfoRes || {}),
          [action.payload.bookingNo]: state[action.payload.bookingNo]
            ? {
                ...state[action.payload.bookingNo],
                ...newData,
              }
            : newData,
        },
      };
    case bookingInfoConstants.BOOKING_INFO_ERROR:
      newData = {
        isLoading: false,
        error: action.payload.error,
      };
      return {
        ...state,
        bookingIdToInfoRes: {
          ...(state.bookingIdToInfoRes || {}),
          [action.payload.bookingNo]: state[action.payload.bookingNo]
            ? {
                ...state[action.payload.bookingNo],
                ...newData,
              }
            : newData,
        },
      };
    default:
      return state;
  }
};
